"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Container = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Container = exports.Container = _styledComponents["default"].footer.withConfig({
  displayName: "Container",
  componentId: "sc-79vijq-0"
})(["", ";display:flex;flex-wrap:wrap;min-inline-size:0;padding-block:24px;border-block-start:1px solid var(--decorative-subdued,", ");@media (min-width:", "){padding-inline:", ";}nav{min-inline-size:0;}> :last-child{display:flex;align-items:flex-end;justify-content:flex-end;flex-grow:1;flex-shrink:0;}"], (0, _index.rootStyle)(), _index.defaultColorSet.decorative.subdued, _encoreFoundation.screenSmMin, (0, _index.cssSpacing)('tighter-2', '8px'));
var _default = exports["default"] = Container;